/* PD Footer : accordéons des colonnes de menus sur mobile (titre cliquable + / −). */
(function () {
  function initFooter(root) {
    if (!root || root.dataset.pdFooterReady) return;
    root.dataset.pdFooterReady = 'true';

    root.querySelectorAll('[data-pd-footer-accordion]').forEach((col) => {
      const toggle = col.querySelector('.pd-footer__toggle');
      if (!toggle) return;
      toggle.addEventListener('click', () => {
        const open = !col.classList.contains('is-open');
        col.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
      });
    });
  }

  const initAll = (scope) => scope.querySelectorAll('[data-pd-footer]').forEach(initFooter);

  initAll(document);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
